import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';
import { NgParticlesModule } from "ng-particles";
import { CarouselModule } from 'ngx-owl-carousel-o';

import { PagesRoutingModule } from './pages-routing.module'

import { SharedModule } from '../shared/shared.module';
import { Index1Component } from './index1/index1.component';
import { Index2Component } from './index2/index2.component';
import { Index3Component } from './index3/index3.component';
import { Index4Component } from './index4/index4.component';
import { Index5Component } from './index5/index5.component';
import { Index6Component } from './index6/index6.component';
import { Index7Component } from './index7/index7.component';
import { Index8Component } from './index8/index8.component';
import { Index9Component } from './index9/index9.component';
import { Index10Component } from './index10/index10.component';
import { Index11Component } from './index11/index11.component';
import { Index12Component } from './index12/index12.component';
import { Index13Component } from './index13/index13.component';
import { LoginComponent } from './login/login.component';
import { PasswordForgetComponent } from './password-forget/password-forget.component';
import { SignupComponent } from './signup/signup.component';

@NgModule({
  declarations: [Index1Component, Index2Component, Index3Component, Index4Component, Index5Component, Index6Component, Index7Component, Index8Component, Index9Component, Index10Component, Index11Component, Index12Component, Index13Component, LoginComponent, PasswordForgetComponent, SignupComponent],
  imports: [
    CommonModule,
    SharedModule,
    PagesRoutingModule,
    ScrollToModule.forRoot(),
    NgParticlesModule,
    CarouselModule
  ]
})
export class PagesModule { }
